import * as React from "react";
import { List, Datagrid, TextField, Show, SimpleShowLayout } from "react-admin";
import { JsonField } from "../../components/JsonField";
import { TechInfo } from "../../components/ui";

export default {
  list: () => (
    <List perPage={50}>
      <Datagrid rowClick="show" bulkActionButtons={false}>
        <TextField source="code" label="Code" />
        <TextField source="label" label="Thème" />
      </Datagrid>
    </List>
  ),
  show: () => (
    <Show>
      <SimpleShowLayout>
        <TextField source="code" label="Code" />
        <TextField source="label" label="Thème" />
        <JsonField source="__all__" />
        <TechInfo />
        </SimpleShowLayout>
    </Show>
  ),
};
